module.exports = __webpack_public_path__ + "img/modal-complete-icon.50170661.svg";